import * as React from 'react';
import { RawRadio } from './radio';
import styles from './radio.css';
import { Fieldset } from './fieldset';
export const RadioGroup = ({ name, description, classes, options, action, selectedValue, dataTestId, }) => (React.createElement(Fieldset, { classes: classes, description: description, "data-test-id": dataTestId }, options.map(opt => (React.createElement(RawRadio, { key: opt.value, classes: styles.RadioGroupOption, name: name, label: opt.label, input: {
        value: opt.value,
        checked: selectedValue === opt.value,
        onChange: () => action(opt.value),
    }, "data-test-id": opt.dataTestId })))));
